module.exports = __webpack_public_path__ + "static/media/no-leaves-found.d7ffb68e.svg";